import React from 'react';
import { ChevronDown } from 'lucide-react';
export function HeroSection() {
  return <section id="hero" className="relative min-h-[85vh] flex items-center justify-center overflow-hidden" data-id="element-557">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-558">
        <img src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?q=80&w=2000&auto=format&fit=crop" alt="Hands together in unity" className="w-full h-full object-cover" data-id="element-559" />
        <div className="absolute inset-0 bg-[#0A5E5C]/80 mix-blend-multiply" data-id="element-560" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-transparent to-black/30" data-id="element-561" />
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 text-center max-w-4xl pt-20" data-id="element-562">
        <span className="inline-block py-1 px-3 rounded-full bg-[#D4A843]/20 text-[#D4A843] border border-[#D4A843]/30 text-sm font-medium mb-6 backdrop-blur-sm animate-fade-in" data-id="element-563">
          Неурядова громадська організація
        </span>

        <h1 className="text-4xl md:text-6xl lg:text-7xl font-serif font-bold text-white mb-6 leading-tight drop-shadow-lg" data-id="element-564">
          Простір Чесної Гри
        </h1>

        <p className="text-lg md:text-xl text-white/90 mb-10 max-w-2xl mx-auto leading-relaxed font-light" data-id="element-565">
          Будуємо простір чесності, розуміння і співпраці у сфері азартних ігор.
          Захищаємо права гравців, допомагаємо запобігати та долати залежність.
        </p>

        <a href="https://fgsu.org/" className="inline-block px-8 py-3 bg-[#D4A843] text-white font-semibold rounded-lg shadow-lg shadow-[#D4A843]/20 hover:bg-[#c49a3a] transition-colors min-w-[200px] text-center" data-id="element-566">
          На головну
        </a>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-white/70 animate-bounce" data-id="element-567">
        <ChevronDown size={32} data-id="element-568" />
      </div>
    </section>;
}